/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <ion-page class="ion-page">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button default-href="/carpools/home"></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center">{{ $t('Incentives.titles') }}</h1>
      </ion-toolbar>
    </ion-header>

    <ion-content id="events" color="primary" forceOverscroll="false">
      <div class="mc-white-container">
        <div class="ion-text-center ion-margin-top" v-if="loading">
          <ion-icon size="large" color="primary" class="rotating" name="sync"></ion-icon>
        </div>

        <div class="ion-text-center ion-margin-top" v-if="!loading && incentives.length == 0">
          {{ $t('Incentives.no-incentives')}}
        </div>

        <div v-if="!loading && incentives.length > 0">
        <ion-item
          item
          v-for="(incentive, index) in incentives"
          :key="index"
          v-on:click="goToIncentive(incentive.id)"
        >
          <div class="mb-15">
            <h3>{{incentive.title}}</h3>
            <div class="incentive-desc ellipsis" v-html="incentive.description"></div>
          </div>

        </ion-item>
        </div>

      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss">
.incentive-desc {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Nombre de lignes à afficher */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<script>
import { toast } from "../../Shared/Mixin/toast.mixin";

export default {
  name: "incentives",
  mixins: [toast],
  data() {
    return {
      loading: false,
      incentives: []
    };
  },
  created() {

  },
  mounted() {
    this.getAllIncentives()
  },
  methods: {
    getAllIncentives() {
      this.loading = true;
      this.$store.dispatch("incentives").then(resp => {
          this.incentives = resp
          this.loading = false;
        }).catch(error => {
          this.presentToast(this.$t("Commons.error"), "danger");
          this.loading = false;
        });
    },
    goToIncentive(incentiveId) {
      this.$router.push({
        name: "incentive",
        params: { id: incentiveId }
      });
    },

  }
};
</script>
